import { createRootRoute, Outlet } from '@tanstack/react-router';

import { NessoLogo } from '@nesso/ui/icons/nesso-logo';
import { Toaster } from '@nesso/ui/primitives/sonner';
import { ThemeProvider } from '@nesso/ui/providers/theme-provider';

import { ErrorBoundary } from '@/app/error-boundary';
import { appConfig } from '@/shared/config/app-config';
import { BrowserGuard } from '@/shared/ui/guards/browser-guard';

function RootComponent() {
    return (
        // ThemeProvider is required by <Toaster/> (sonner reads the theme via useTheme).
        <ThemeProvider attribute="class" defaultTheme="light" disableTransitionOnChange>
            <BrowserGuard />
            {/* Before <Outlet/>: sonner drops any toast published while it has no subscriber, and
                a route can toast from a mount effect. */}
            <Toaster />
            <div className="bg-background flex min-h-dvh flex-col pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]">
                <nav className="fixed top-0 left-0 right-0 z-50 w-full flex items-center p-4">
                    <a href={appConfig.marketingSiteUrl} aria-label="Go to Nesso home">
                        <NessoLogo />
                    </a>
                </nav>
                <div className="flex flex-1 flex-col">
                    <Outlet />
                </div>
            </div>
        </ThemeProvider>
    );
}

export const Route = createRootRoute({
    component: RootComponent,
    errorComponent: ErrorBoundary,
});
